import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { MapPin, Clock, Phone, Mail } from 'lucide-react';
import { businessInfo } from '../mock';

const Location = () => {
  return (
    <section id="ubicacion" className="py-20 bg-gradient-to-br from-[#F0FFF4] to-[#FFF8E7]">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="text-[#FFB830]">Encuéntranos</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Visítanos y disfruta de nuestros productos frescos y naturales
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {/* Map */}
          <div className="rounded-2xl overflow-hidden shadow-xl border-4 border-white">
            <div className="w-full h-96 bg-gray-200 flex items-center justify-center">
              <div className="text-center">
                <MapPin size={48} className="text-[#7CB342] mx-auto mb-4" />
                <p className="text-gray-600 font-medium">Mapa interactivo</p>
                <p className="text-sm text-gray-500 mt-2">Ubicación: {businessInfo.address}</p>
              </div>
            </div>
          </div>

          {/* Info Cards */}
          <div className="space-y-6">
            {/* Address Card */}
            <Card className="border-2 border-[#7CB342]/20 hover:shadow-lg transition-shadow duration-300">
              <CardHeader className="pb-4">
                <CardTitle className="flex items-center text-[#7CB342]">
                  <MapPin className="mr-3" size={24} />
                  Dirección
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-700 text-lg font-medium">{businessInfo.address}</p>
                <p className="text-gray-600 mt-1">{businessInfo.city}</p>
              </CardContent>
            </Card>

            {/* Hours Card */}
            <Card className="border-2 border-[#FFB830]/20 hover:shadow-lg transition-shadow duration-300">
              <CardHeader className="pb-4">
                <CardTitle className="flex items-center text-[#FFB830]">
                  <Clock className="mr-3" size={24} />
                  Horarios
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-2">
                <div className="flex justify-between items-center py-2 border-b border-gray-200">
                  <span className="text-gray-600">Domingo - Jueves</span>
                  <span className="font-semibold text-gray-800">6:00 AM - 10:00 PM</span>
                </div>
                <div className="flex justify-between items-center py-2 border-b border-gray-200">
                  <span className="text-gray-600">Viernes</span>
                  <span className="font-semibold text-gray-800">6:00 AM - 5:00 PM</span>
                </div>
                <div className="flex justify-between items-center py-2">
                  <span className="text-gray-600">Sábado</span>
                  <span className="font-semibold text-red-600">Cerrado</span>
                </div>
                {businessInfo.hours.note && (
                  <p className="text-sm text-[#FFB830] font-semibold mt-2">⚠️ {businessInfo.hours.note}</p>
                )}
              </CardContent>
            </Card>

            {/* Contact Card */}
            <Card className="border-2 border-[#7CB342]/20 hover:shadow-lg transition-shadow duration-300">
              <CardHeader className="pb-4">
                <CardTitle className="flex items-center text-[#7CB342]">
                  <Phone className="mr-3" size={24} />
                  Contacto Rápido
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-3">
                <div className="flex items-center">
                  <Phone size={18} className="text-[#FFB830] mr-3" />
                  <a href={`tel:${businessInfo.phone}`} className="text-gray-700 hover:text-[#7CB342] transition-colors">
                    {businessInfo.phone}
                  </a>
                </div>
                <div className="flex items-center">
                  <Mail size={18} className="text-[#FFB830] mr-3" />
                  <a href={`mailto:${businessInfo.email}`} className="text-gray-700 hover:text-[#7CB342] transition-colors">
                    {businessInfo.email}
                  </a>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
